import { useEffect, useState } from "react";

// Drop-in replacement for useState that survives a refresh by mirroring the
// value to sessionStorage - use for "where am I / what am I looking at"
// navigation-type state (current step, selected record, active sub-view),
// not for transient UI state like loading flags or unsaved draft text.
export function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") {
      return defaultValue;
    }

    const stored = sessionStorage.getItem(key);
    if (stored === null) {
      return defaultValue;
    }

    try {
      return JSON.parse(stored);
    } catch (error) {
      return defaultValue;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
